import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetAudienceQuery } from '@/services/endpoints/audiences';
import { FC } from 'react';
import { Trans } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { AudienceEditableTitle } from './AudienceEditableTitle';
import { DeleteAudienceV2 } from './DeleteAudienceV2';
import { DownloadAudience } from './DownloadAudience';

export const AudienceDetailsHeader: FC = () => {
  const workspace = useWorkspace();
  const { id } = useParams<{ id: string }>();

  const { data: audience } = useGetAudienceQuery({
    workspaceId: workspace.id,
    audienceId: id,
  });

  return (
    <div className='flex items-start justify-between'>
      <section className='flex flex-col gap-1'>
        <AudienceEditableTitle audience={audience} />
        <h3 className='text-tertiary-600'>
          <Trans
            i18nKey={'audiences:subtitle'}
            components={{
              newLine: <br />,
            }}
          />
        </h3>
      </section>
      <div className='flex items-start gap-2'>
        <DownloadAudience audience={audience} />
        <DeleteAudienceV2 audience={audience} />
      </div>
    </div>
  );
};
